import { render, staticRenderFns } from "./AddItemStock.vue?vue&type=template&id=888b5e82"
import script from "./AddItemStock.vue?vue&type=script&lang=js"
export * from "./AddItemStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports